import React from 'react';
import { useContact } from './ContactContext';

const FloatingContactBtn = () => {
  const { openContact, isContactOpen } = useContact();

  if (isContactOpen) return null;

  return (
    <button
      onClick={() => openContact()}
      className="fixed bottom-6 right-6 z-[9900] flex items-center justify-center w-16 h-16 bg-[#6e1e50] text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 animate__animated animate__bounceIn"
      style={{ boxShadow: '0 8px 25px rgba(110, 30, 80, 0.4)' }}
      aria-label="お問い合わせ"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    </button>
  );
};

export default FloatingContactBtn;
